module.exports = __webpack_public_path__ + "e0ec9067bfede725999aaa308e2a7fc6.svg";